import {InjectionToken} from '@angular/core';

export const /** @type {?} */ WINDOW = new InjectionToken('Window');
/**
 * @return {?}
 */
export function _window() { return window; }
